import { z } from 'zod';

// === ML Hour Frontend Schema ===
// Used for managing ml/hr rates and water source settings at the company level.

export const MlHourFrontendSchema = z.object({
  id: z.number().int().positive(),
  company_id: z.string().uuid(),
  rate: z.number().int().nonnegative().default(0),
  water_source: z.string().max(100).nullable().optional(),
  rate_value: z.number().nullable().optional(),
  created_at: z.string(),
  updated_at: z.string(),
  created_by: z.string().nullable().optional(),
  updated_by: z.string().nullable().optional(),
  deleted_at: z.string().nullable().optional(),
});

export const MlHourFrontendCreateSchema = MlHourFrontendSchema.omit({
  id: true,
  company_id: true,
  created_at: true,
  updated_at: true,
  deleted_at: true,
});

export const MlHourFrontendUpdateSchema = MlHourFrontendCreateSchema.partial();

export const MlHourFrontendListQuerySchema = z.object({
  search: z.string().optional(),
  page: z.coerce.number().int().positive().optional().default(1),
  per_page: z.coerce.number().int().positive().max(200).optional().default(25),
});

export type MlHourFrontend = z.infer<typeof MlHourFrontendSchema>;
export type MlHourFrontendCreate = z.infer<typeof MlHourFrontendCreateSchema>;
export type MlHourFrontendUpdate = z.infer<typeof MlHourFrontendUpdateSchema>;
export type MlHourFrontendListQuery = z.infer<typeof MlHourFrontendListQuerySchema>;
